import { render, staticRenderFns } from "./NYCXDiscountByTotalTable.vue?vue&type=template&id=f93675f6"
import script from "./NYCXDiscountByTotalTable.vue?vue&type=script&lang=ts"
export * from "./NYCXDiscountByTotalTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports